import React from 'react'

const LoadingFloter = () => {
  return (
    <div className="fixed top-32 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-yellow-100 border border-yellow-50 text-yellow-900 px-4 py-2 rounded-full shadow-md text-sm font-semibold">
        Loading...
      </div>
    </div>
  );
}

export default LoadingFloter